import React, { useRef, useEffect, useState } from 'react';
import cn from 'classnames';
import throttle from '@insight/toolkit-utils/lib/timing/throttle';
import Tooltip from '../Tooltip/Tooltip';

const TextView = ({
  text,
  children,
  className,
  resizeThrottle = 250,
  tooltip = { position: 'top' },
  ...rest
}) => {
  const textElementRef = useRef();
  const [hasHiddenText, setHasHiddenText] = useState(false);

  const computeIfEllipsisNeeded = throttle(() => {
    const width = textElementRef.current
      ? textElementRef.current.offsetWidth
      : 0;
    const scrollWidth = textElementRef.current
      ? textElementRef.current.scrollWidth
      : 0;
    setHasHiddenText(width < scrollWidth);
  }, resizeThrottle);

  useEffect(() => {
    computeIfEllipsisNeeded();
  }, [textElementRef.current]);

  useEffect(() => {
    window.addEventListener('resize', computeIfEllipsisNeeded);
    return () => {
      window.removeEventListener('resize', computeIfEllipsisNeeded);
    };
  }, []);

  const content = (
    <div ref={textElementRef} className="u-truncate u-no-wrap">
      {text || children}
    </div>
  );
  if (hasHiddenText) {
    return (
      <div className={cn('o-text-view', className)} {...rest}>
        <Tooltip content={text || children} {...tooltip}>
          {content}
        </Tooltip>
      </div>
    );
  }

  return (
    <div className={cn('o-text-view', className)} {...rest}>
      {content}
    </div>
  );
};

export default TextView;
